const normalize = (itemName: string) => itemName && itemName.toLowerCase().replace(/_/g, ' ');

export default normalize;
